import React from 'react';
import {useNavigate} from 'react-router';

import PageHeader from '@/components/common/pageHeader/PageHeader';
import {LoadingSpinningLogoComponent} from '@/components/loadingSpinningLogoComponent';

type PagePropsT = {
  children: React.ReactNode;
  currentPage?: string;
  activePage?: string;
  mainPage?: string;
  isLoading?: boolean | null;
  handleBack?: () => void;
};

function Page({
  children,
  isLoading = null,
  currentPage,
  activePage = 'Dashboards',
  mainPage = currentPage,
  handleBack,
}: PagePropsT) {
  const navigate = useNavigate();

  return (
    <>
      <PageHeader
        currentPage={currentPage ?? ''}
        activePage={activePage ?? ''}
        mainPage={mainPage ?? ''}
        handleBack={handleBack ?? (() => navigate(-1))}
      />
      {isLoading !== null && isLoading ? <LoadingSpinningLogoComponent /> : <>{children}</>}
    </>
  );
}

export default Page;
